export enum FathomMeetingStatus {
  PENDING = "pending",
  REVIEW = "review",
  PROCESSED = "processed",
  ARCHIVED = "archived",
}
